import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from "onefaceui-react-components";

import { getResourceTo, replaceSizeAliasAndType } from "react/utils/utils";

import { TableHeader, TableItem } from './styles';

const SizesTable = (props) => {
  const { stopData } = props;

  return (
    <Flex flexDirection="column">
      <TableHeader className="col-4">
        <Text size="xxs" asChild>
          <span>{getResourceTo('equipmentType.size')}</span>
        </Text>
        <Text size="xxs" asChild>
          <span>{replaceSizeAliasAndType(getResourceTo('Stop.popup.actualSize1'))}</span>
        </Text>
        <Text size="xxs" asChild>
          <span>{replaceSizeAliasAndType(getResourceTo('Stop.popup.actualSize2'))}</span>
        </Text>
        <Text size="xxs" asChild>
          <span>{replaceSizeAliasAndType(getResourceTo('Stop.popup.actualSize3'))}</span>
        </Text>
      </TableHeader>
      <TableItem className="col-4">
        <Text size="xxs" asChild>
          <span>
            {getResourceTo('RouteMonitor.sidebar.stopStatistics.Planned')}
          </span>
        </Text>
        <Text size="xxs" asChild><span>{stopData.plannedSize1}</span></Text>
        <Text size="xxs" asChild><span>{stopData.plannedSize2}</span></Text>
        <Text size="xxs" asChild><span>{stopData.plannedSize3}</span></Text>
      </TableItem>
      <TableItem className="col-4">
        <Text size="xxs" asChild>
          <span>
            {getResourceTo('notificationPanel.actual')}
          </span>
        </Text>
        <Text size="xxs" asChild><span>{stopData.actualSize1}</span></Text>
        <Text size="xxs" asChild><span>{stopData.actualSize2}</span></Text>
        <Text size="xxs" asChild><span>{stopData.actualSize3}</span></Text>
      </TableItem>
    </Flex>
  );
};

SizesTable.propTypes = {
  stopData: PropTypes.object.isRequired,
};

export default SizesTable;
